<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.cancel' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>
      @if (dummy()) {
        {{ 'sites.new.addContact' | translate }}
      } @else {
        {{ 'users.newUser' | translate }}
      }
    </h2>
  </div>

  <form class="invite-dialog"
    id="invite-user-form"
    [formGroup]="formGroup">
    <section class="invite-dialog__panel">
      <label class="invite-dialog__field">
        <span>{{ 'users.displayName' | translate }}</span>
        <ion-item lines="none">
          <ion-input autocapitalize="on"
            formControlName="displayName"></ion-input>
        </ion-item>
      </label>

      <label class="invite-dialog__field">
        <span>{{ 'register.form.email' | translate }}</span>
        <ion-item lines="none">
          <ion-input formControlName="email"
            type="email"></ion-input>
        </ion-item>
      </label>

      @if (dummy()) {
        <label class="invite-dialog__field">
          <span>{{ 'register.form.phone' | translate }}</span>
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              formControlName="phone"
              type="tel"></ion-input>
          </ion-item>
        </label>
      }

      @if (['storage', 'worker'].includes(formGroup.value.role)) {
        <div class="invite-dialog__address"
          formGroupName="address">
          <label class="invite-dialog__field">
            <span>{{ 'register.form.street' | translate }}</span>
            <ion-item lines="none">
              <ion-input autocapitalize="on"
                aria-label=""
                formControlName="street"></ion-input>
            </ion-item>
          </label>
          <div class="invite-dialog__row">
            <label class="invite-dialog__field">
              <span>{{ 'register.form.postalCode' | translate }}</span>
              <ion-item lines="none">
                <ion-input autocapitalize="on"
                  aria-label=""
                  formControlName="postalCode"></ion-input>
              </ion-item>
            </label>
            <label class="invite-dialog__field">
              <span>{{ 'register.form.city' | translate }}</span>
              <ion-item lines="none">
                <ion-input autocapitalize="on"
                  aria-label=""
                  formControlName="city"></ion-input>
              </ion-item>
            </label>
          </div>
        </div>
      }

      @if (role() == null) {
        @if (roles$ | async; as roles) {
          <label class="invite-dialog__field">
            <span>{{ 'users.role' | translate }}</span>
            <ion-item lines="none">
              <ion-select aria-label=""
                label-placement="stacked"
                [placeholder]="'general.select' | translate"
                class="tw:w-full"
                interface="popover"
                formControlName="role">
                @for (role of roles; track role) {
                  <ion-select-option [value]="role">
                    {{ 'users.roles.' + role | translate }}
                  </ion-select-option>
                }
              </ion-select>
            </ion-item>
          </label>
        }
      }

      @if (userRoleS() === 'super-admin') {
        <label class="invite-dialog__field">
          <span>{{ 'nav.contractors' | translate }}</span>
          <ion-select formControlName="contractors" [multiple]="true"
            [label]="'nav.contractors' | translate" interface="popover">
            @for (contractor of contractors$ | async; track contractor.guid) {
              <ion-select-option [value]="contractor.guid">{{ contractor.name }}</ion-select-option>
            }
          </ion-select>
        </label>
      }

      @if (['storage', 'worker', 'admin'].includes(formGroup.value.role)) {
        <div class="invite-dialog__checkbox">
          <ion-checkbox aria-label=""
            color="light"
            disabled="true"
            labelPlacement="end"
            [checked]="true">
            {{ 'users.sendInviteInfo' | translate }}
          </ion-checkbox>
        </div>
      }

      @if (['calendar'].includes(formGroup.value.role)) {
        <label class="invite-dialog__field">
          <span>{{ 'users.company' | translate }}</span>
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              aria-label=""
              formControlName="company"></ion-input>
          </ion-item>
        </label>
      }
    </section>
  </form>

  <div modalFooter>
<ion-button fill="clear"
        color="medium"
        type="button"
        (click)="dismiss()">
        {{ 'general.cancel' | translate }}
      </ion-button>
      <ion-button fill="solid"
        type="button"
        [disabled]="!formGroup.valid"
        (click)="onSave()">
        {{ 'general.save' | translate }}
      </ion-button>
</div>
</app-modal-shell>